mutation DeletePoll($pollId: ID!) {
  result: StreamToolsDeletePoll(pollId: $pollId) {
    id
    deleted
  }
}
